import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    codeProp: 'ruleUserCode',
    mapProp: 'ruleMap',
    name: '重要规则',
    ownerIdProp: 'rmId',
    ownerTextProp: 'rmName',
    ownerType: 'RULEMRM',
    textProp: 'ruleTitle',
    type: 'RULEMRMRULE',
}
